// app/javascript/controllers/popover_controller.js
import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

export default class extends Controller {
  connect() {
    this.popover = new Popover(this.element, {
      trigger: this.element.dataset.bsTrigger || 'hover click',
      placement: this.element.dataset.bsPlacement || 'top',
      content: this.element.dataset.bsContent || '',
      html: true
    })
    console.log(this.element.dataset.bsTrigger)
  }

  disconnect() {
    if (this.popover) {
      this.popover.dispose()
    }
  }
}
